import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import { EventSource } from './eventSource';

import { nullSorter } from './sort';

export interface QA {
    answer: string;
    question: string;
    sortKey?: number;
    qandaId?: string;
    key: string;
}

import { Photo } from './interfaces';

export class EventStory {

    private es: EventSource;

    constructor(eventSource: EventSource) {
        this.es = eventSource;
    }

    public observeStory(): Observable<{ title: string, story: string }> {
        return Observable.combineLatest(
            this.es.pluckPublicInfo(['stringOverrides', 'story']),
            this.es.pluckData(this.es.observeStoryPage(), ['custom', 'story'])
        ).map(data => ({ title: Object.keys(data[0]).length > 0 ? data[0] : 'Story', story: data[1] }));
    }

    public observeQandas(): Observable<{title: string, faqs: Array<QA> }> {
        return Observable.combineLatest(
            this.es.pluckPublicInfo(['stringOverrides', 'tidbits']),
            this.es.pluckData(this.es.observeStoryPage(), ['qandas'])
                .map(qa => Object.keys(qa).map((key, idx) => {
                    qa[key].key = key;
                    qa[key].sortKey = (qa[key].sortKey && !isNaN(parseInt(qa[key].sortKey))) ? parseInt(qa[key].sortKey) : idx;
                    return qa[key] 
                }).filter(x => x)).map(data => data.sort(nullSorter))
        ).map(data => ({ title: Object.keys(data[0]).length > 0 ? data[0] : 'Tidbits', faqs: data[1] }));
            
    }

    public observePrimaryFaqPhoto(): Observable<Photo> {
        return this.es.observePrimaryPhoto(this.es.observeStoryPage());
    }
    
    public observePrimaryFaqPhotoHorizontal(): Observable<Photo> {
        return this.es.observePrimaryPhotoHorizontal(this.es.observeStoryPage());
    }
}
